import React from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Box from '@mui/material/Box';
import EventBusyRoundedIcon from '@mui/icons-material/EventBusyRounded';
import AutoAwesomeRoundedIcon from '@mui/icons-material/AutoAwesomeRounded';
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import InsightsRoundedIcon from '@mui/icons-material/InsightsRounded';
import VisibilityRoundedIcon from '@mui/icons-material/VisibilityRounded';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import GavelRoundedIcon from '@mui/icons-material/GavelRounded';
import OpenInNewRoundedIcon from '@mui/icons-material/OpenInNewRounded';
import { dsV2 } from '@bloomays-lib/ui.shared';

export type ActionEntry = { key: string; label: string; danger?: boolean; onClick: () => void };

const ICONS: Record<string, React.ReactNode> = {
  shorten: <EventBusyRoundedIcon sx={{ fontSize: 16 }} />,
  amendment: <AutoAwesomeRoundedIcon sx={{ fontSize: 16 }} />,
  modify: <EditRoundedIcon sx={{ fontSize: 16 }} />,
  assessment: <InsightsRoundedIcon sx={{ fontSize: 16 }} />,
  prices: <VisibilityRoundedIcon sx={{ fontSize: 16 }} />,
  delete: <DeleteRoundedIcon sx={{ fontSize: 16 }} />,
  cra: <CalendarMonthRoundedIcon sx={{ fontSize: 16 }} />,
  contracts: <GavelRoundedIcon sx={{ fontSize: 16 }} />,
  v1: <OpenInNewRoundedIcon sx={{ fontSize: 16 }} />,
};

/** Menu déroulant « Actions mission » (`.dd-menu` / `.dd-item`) — valeurs exactes de la maquette V2. */
export const ActionsMenu = ({
  anchorEl,
  onClose,
  items,
  navItems,
}: {
  anchorEl: HTMLElement | null;
  onClose: () => void;
  items: ActionEntry[];
  navItems: ActionEntry[];
}) => {
  const renderItem = (entry: ActionEntry, last: boolean) => (
    <MenuItem
      key={entry.key}
      onClick={() => {
        onClose();
        entry.onClick();
      }}
      disableRipple
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        padding: '10px 15px',
        fontSize: '12.5px',
        fontFamily: dsV2.font.sans,
        color: entry.danger ? dsV2.color.rouge : dsV2.color.t2,
        borderBottom: last ? 'none' : `1px solid ${dsV2.color.borderLight}`,
        '&:hover': {
          backgroundColor: entry.danger ? dsV2.color.rougeDim : dsV2.color.surface2,
          color: entry.danger ? dsV2.color.rouge : dsV2.color.noir,
        },
      }}
    >
      <Box sx={{ display: 'flex', color: entry.danger ? dsV2.color.rouge : dsV2.color.t4 }}>{ICONS[entry.key]}</Box>
      {entry.label}
    </MenuItem>
  );

  const all = [...items, ...navItems];
  return (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      slotProps={{
        paper: {
          sx: {
            marginTop: '6px',
            minWidth: 215,
            border: `1px solid ${dsV2.color.border}`,
            borderRadius: dsV2.radius.sm,
            boxShadow: dsV2.shadow.lg,
            overflow: 'hidden',
          },
        },
        list: { sx: { padding: 0 } },
      }}
    >
      {all.map((entry, i) => renderItem(entry, i === all.length - 1))}
    </Menu>
  );
};

export default ActionsMenu;
